import { getRequest, putRequest } from 'utils/http'

export const get360 = () => {
  return getRequest('/pillars')
}

export const editSteps = payload => {
  return putRequest('/pillars', payload)
}
